import { render } from "./ModalEditNicknameFavorite.vue?vue&type=template&id=bfae6d3e&scoped=true"
import script from "./ModalEditNicknameFavorite.vue?vue&type=script&lang=js"
export * from "./ModalEditNicknameFavorite.vue?vue&type=script&lang=js"

import "./ModalEditNicknameFavorite.vue?vue&type=style&index=0&id=bfae6d3e&scoped=true&lang=css"

import exportComponent from "C:\\projeto\\dynamik\\dynamik_webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfae6d3e"]])

export default __exports__